import domReady from '@wordpress/dom-ready';

domReady(() => {
  const btns = document.querySelectorAll(
    '.popup .btn, .home_banner .btn, .entry-content .btn, .wp-block-button .wp-element-button, .btn-secondary, .site-footer .btn-secondary'
  );

  if (btns) {
    btns.forEach((button) => {
      const parent = button.closest('.wp-block-button');

      button.innerHTML =
        '<span class="icon btn-icon icon-arrow-right-small"></span><span class="icon-label btn-label">' +
        button.innerHTML +
        '</span>';

      if (
        (parent && parent.classList.contains('is-style-secondary')) ||
        button.classList.contains('btn-secondary')
      ) {
        const icon = button.querySelector('.btn-icon');
        const text = button.querySelector('.btn-label');

        if (icon && text) {
          button.addEventListener('mouseenter', () => {
            const iconWidth = icon.offsetWidth;
            const textWidth = text.offsetWidth;

            icon.style.transform = `translateX(${textWidth}px)`;
            text.style.transform = `translateX(-${iconWidth}px)`;
          });

          button.addEventListener('mouseleave', () => {
            icon.style.transform = `translateX(0)`;
            text.style.transform = `translateX(0)`;
          });
        }
      }
    });
  }

  const btnSticky = document.querySelector('.sticky-button');
  if (btnSticky) {
    const icon = btnSticky.querySelector('.sticky-button__icon');
    const text = btnSticky.querySelector('.sticky-button__title');

    if (icon && text) {
      btnSticky.addEventListener('mouseenter', () => {
        const iconWidth = icon.offsetWidth;
        const textWidth = text.offsetWidth;

        icon.style.transform = `translateX(-${textWidth}px)`;
        text.style.transform = `translateX(${iconWidth}px)`;
      });

      btnSticky.addEventListener('mouseleave', () => {
        icon.style.transform = `translateX(0)`;
        text.style.transform = `translateX(0)`;
      });
    }
  }

  const btnsDonation = document.querySelectorAll('.btn-donation');

  function updateActiveDonation() {
    btnsDonation.forEach((btn) => {
      const href = btn.getAttribute('href');
      if (href && window.location.href.includes(href)) {
        btn.classList.add('btn-donation-active');
      } else {
        btn.classList.remove('btn-donation-active');
      }
    });
  }

  updateActiveDonation();

  btnsDonation.forEach((btn) => {
    btn.addEventListener('click', () => {
      setTimeout(updateActiveDonation, 100);
    });
  });
});
